export enum MailingActionTypes {
    GET_MAILING_LISTS = "[App Action][Mailing] GET MAILING LISTS",
    GET_MAILING_LISTS_SUCCESS = "[App Action][Mailing] GET MAILING LISTS SUCCESS",
    GET_MAILING_LISTS_FAIL = "[App Action][Mailing] GET MAILING LISTS FAIL",

    GET_MAILING_LIST = "[App Action][Presets] GET MAILING LIST",
    GET_MAILING_LIST_SUCCESS = "[App Action][Presets] GET MAILING LIST SUCCESS",
    GET_MAILING_LIST_FAIL = "[App Action][Presets] GET MAILING LIST FAIL",
    UPDATE_MAILING_LISTS = "[App Action][Mailing] UPDATE MAILING LISTS",
    CLEAR_MAILING_LISTS = "[App Action][Presets] CLEAR MAILING LISTS",
    CLEAR_SUBMIT_MAILING_LIST = "[App Action][Presets] CLEAR SUBMIT MAILING LIST",

    EDIT_MAILING_LIST = "[App Action][Presets] EDIT MAILING LIST",
    EDIT_MAILING_LIST_SUCCESS = "[App Action][Presets] EDIT MAILING LIST SUCCESS",
    EDIT_MAILING_LIST_FAIL = "[App Action][Presets] EDIT MAILING LIST FAIL",

    ADD_MAILING_LISTS = "[App Action][Mailing] ADD MAILING LISTS",
    ADD_MAILING_LISTS_SUCCESS = "[App Action][Mailing] ADD MAILING LISTS SUCCESS",
    ADD_MAILING_LISTS_FAIL = "[App Action][Mailing] ADD MAILING LISTS FAIL",

    GET_SUBSIDIARIES = "[App Action][Mailing] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Mailing] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Mailing] GET SUBSIDIARIES FAIL",

    GET_MAILING_LISTS_TYPES = "[App Action][Mailing] GET MAILING LISTS TYPES",
    GET_MAILING_LISTS_TYPES_SUCCESS = "[App Action][Mailing] GET MAILING LISTS TYPES SUCCESS",
    GET_MAILING_LISTS_TYPES_FAIL = "[App Action][Mailing] GET MAILING LISTS TYPES FAIL",

    TOGGLE_MAILING_LIST_ACTIVE = "[App Action][Presets] TOGGLE MAILING LIST ACTIVE",
    TOGGLE_MAILING_LIST_ACTIVE_SUCCESS = "[App Action][Presets] TOGGLE MAILING LIST SUCCESS",
    TOGGLE_MAILING_LIST_ACTIVE_FAIL = "[App Action][Presets] TOGGLE MAILING LIST ACTIVE FAIL"
}
